import { useEffect, useCallback } from "react";

function usePrompt(message, when = true) {
  const confirmNavigation = useCallback(() => {
    if (!when) return true;
    return window.confirm(message);
  }, [when, message]);

  // Block browser back/forward button
  useEffect(() => {
    if (!when) return undefined;
    const handlePopState = (event) => {
      if (!confirmNavigation()) {
        // Push the state back to cancel the navigation
        window.history.pushState(event.state, '');
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [when, confirmNavigation]);
}

export default usePrompt;
